/* global G */
/* eslint-disable no-unused-vars */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'

const _getLabel = (intl, {
  [G.CONFIGURATION]: { t: { label: { options: t = {} } = {} } = {} } = {},
}) => intl._t(t._key, t)

/**
 * Displays costObject, isCovered and chargeable as the step's title and subtitle if defined.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const setStepState = module => async (components, ...args) => {
  const { [G.INTL]: intl } = module[G.ADAPTER]
  const model = module[G.MODEL]
  const { billing: billingModel, warranty: warrantyModel } = model[G.CHILDREN]

  const { component, chargeable, costObject, isCovered } = components

  const stepState = component[G.STATE]

  const stepTitle = []
  if (billingModel[G.CHILDREN].chargeable[G.CACHE]) {
    stepTitle.push(_getLabel(intl, chargeable))
  }

  const costObjectCache = billingModel[G.CHILDREN].costObject[G.CACHE]
  if (costObjectCache) {
    stepTitle.push(`${_getLabel(intl, costObject)} ${costObjectCache}`)
  }

  stepState.title = stepTitle.filter(x => !!x).join(', ')

  if (warrantyModel[G.CHILDREN].isCovered[G.CACHE]) {
    stepState.subtitle = _getLabel(intl, isCovered)
  }

  return [components, ...args]
}

/**
 * Internal information step.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => await asyncPipeSpread(
  setStepState(module),
)(find(component), ...args)
